import {useTrackOnFilterOpen} from '@aboutyou/tracking';
import {FilterAndSortFAB} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useFilterFlyout} from '../shared/useFilterFlyout';

interface FilterAndSortFABViewProps {
  count: number;
  label: string;
}

export const FilterAndSortFABView: React.FC<FilterAndSortFABViewProps> = ({
  count,
  label,
}) => {
  const {open} = useFilterFlyout();
  const trackOnFilterOpen = useTrackOnFilterOpen();

  const handleOpen = () => {
    trackOnFilterOpen('', 'filter_modal');
    open();
  };

  return (
    <Wrapper>
      <FilterAndSortFAB count={count} onClick={handleOpen} label={label} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
`;
